import { AemFeature } from '@app/components/AdobeExperienceFragments';
import { CommonQuestions } from '@app/components/CommonQuestions';
import { MobileProfileButton } from '@app/components/MobileProfileButton';
import { PageLayout } from '@app/components/PageLayout';
import { useCommonQuestionsFeature } from '@app/utils/useCommonQuestionsFeature';

import AlertsSection from './alerts';
import ArticleBanner from './article-banner';
import BalanceSummary from './billing-summary';
import InvoiceHistory from './invoice-history';

import styles from './home.module.scss';

const BillingHome = (): JSX.Element => {
  const overviewCommonQuestionsFeature = useCommonQuestionsFeature({
    fiber: AemFeature.BILLING_COMMON_QUESTIONS_FIBER,
    default: AemFeature.BILLING_COMMON_QUESTIONS,
  });

  return (
    <>
      <MobileProfileButton />
      <PageLayout>
        <AlertsSection />
        <div data-cy="billing-body" className={styles['bodyGrid']}>
          <div className={styles['balanceSummaryMargin']}>
            <BalanceSummary />
          </div>

          <div className={styles['commonQuestionsMargin']}>
            <div className={styles['commonQuestionsWrapper']}>
              <CommonQuestions feature={overviewCommonQuestionsFeature} />
            </div>
          </div>

          <div className={styles['rightSide']}>
            <div className={styles['invoiceMargin']}>
              <InvoiceHistory />
            </div>

            <div className={styles['articleMargin']}>
              <ArticleBanner />
            </div>
          </div>
        </div>
      </PageLayout>
    </>
  );
};

export default BillingHome;
